module.exports = __webpack_public_path__ + "49db6469af84efee2be311f5a0a6156d.svg";